import { createTypes } from "@/store/utils";

export const FETCH_MAIL_PIECES_DETAILED_COUNT = createTypes(
  "FETCH_MAIL_PIECES_DETAILED_COUNT"
);

export const FETCH_MAIL_PIECES_TOTAL = createTypes("FETCH_MAIL_PIECES_TOTAL");
export const FILTER_TEMPLATES = createTypes("FILTER_TEMPLATES");
export const RESET_DASHBOARD = "RESET_DASHBOARD";
export const SET_DATES = "SET_DATES";
export const SET_TEMPLATE_FILTER = "SET_TEMPLATE_FILTER";
export const SET_QUICK_FILTER = "SET_QUICK_FILTER";
